module.exports = __webpack_public_path__ + "static/media/landing_course3.3702c726.jpg";